import { MAX_PAGE_SIZE } from '../constants/constants'
import { urlList } from '../constants/urlConstant'
import apiService from './apiService'

const baseUrl = urlList.USERS

const getUsers = async () => {
  return apiService
    .fetchItems(
      `${baseUrl}?pageSize=${MAX_PAGE_SIZE}&includeInactive=true`
    )
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.error('axios get error', error)
      throw error
    })
}

const exportUserList = async () => {
  return apiService
    .fetchItems(`${baseUrl}/csv`)
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.error('axios get error', error)
      throw error
    })
}

interface ExportUserDetailsProps {
  userId: string
}
const exportUserDetails = async ({ userId }: ExportUserDetailsProps) => {
  return apiService
    .fetchItems(`${baseUrl}/${userId}/csv`)
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.error('axios get error', error)
      throw error
    })
}

interface GetUsersWithSearchQueryProps {
  searchQuery: string
}

const getUsersWithSearchQuery = async ({
  searchQuery,
}: GetUsersWithSearchQueryProps) => {
  return apiService
    .fetchItems(
      `${baseUrl}?searchQuery=${searchQuery}&pageSize=${MAX_PAGE_SIZE}&includeInactive=true&excludeUnregistered=true`
    )
    .then((response) => {
      return response
    })
}
const userService = {
  getUsers,
  exportUserList,
  exportUserDetails,
  getUsersWithSearchQuery,
}

export default userService
